import { globalActions, globalReducer } from "@/containers/global/slice";
import { landingReducer } from "@/containers/landing/slice";
import { parcelDetailReducer } from "@/containers/parcelDetail/slice";
import { parcelsReducer } from "@/containers/parcels/slice";
import { combineReducers, type Action } from "@reduxjs/toolkit";

/**
 * Add a feature slice here and to `RootState` in `./types.ts` — those two
 * files plus `containers/runSagas.ts` are the whole store wiring.
 *
 * checkout, myFarm and admin deliberately have no slice: their state is local
 * to one screen, nothing else reads it, and `useCheckout` has to hand the
 * parcel page an awaitable promise rather than dispatch an action.
 */
const appReducer = combineReducers({
  global: globalReducer,
  landing: landingReducer,
  parcels: parcelsReducer,
  parcelDetail: parcelDetailReducer,
});

type AppState = ReturnType<typeof appReducer>;

export function createReducer() {
  return (state: AppState | undefined, action: Action): AppState => {
    // Logout wipes everything: no slice has to remember to clear itself, and
    // no buyer's parcels can survive into the next session on a shared device.
    if (action.type === globalActions.resetState.type) {
      return appReducer(undefined, action);
    }
    return appReducer(state, action);
  };
}
